/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramGeoControllerGetCountriesQueryResponse } from '../types/TelegramGeoControllerGetCountries.ts';

function getTelegramGeoGetCountriesUrl() {
  const res = { method: 'GET', url: `/api/telegram/geo/countries` as const };
  return res;
}

/**
 * {@link /api/telegram/geo/countries}
 */
export async function telegramGeoGetCountries(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramGeoControllerGetCountriesQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramGeoGetCountriesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
